import React from 'react';
import { injectIntl } from 'react-intl';
import { colorToArray, i18nIntl, isColorBright, RGB_2_HEX } from '../../lib/ep.js';

const BestScore = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let styles = {};

	const override_promo_styles = props?.override_promo_styles ?? false;
	if(override_promo_styles) {
		styles = {
			'--ep-white-color':'var(--text-color-rgb)',
			'--highlight-bg-color':'var(--main-color), 1',
			'--highlight-text-color':'var(--main-color-text)',
		}
	} else {
		const color_arr = colorToArray(props.custom_success_color);
		const color_text = (isColorBright(RGB_2_HEX(`rgba(${color_arr}, 1)`))) ? '0, 0, 0, 1' : '255, 255, 255, 1'

		styles = {
			'--highlight-bg-color':`${color_arr[0]}, ${color_arr[1]}, ${color_arr[2]}, 1`,
			'--highlight-text-color':color_text,
		}
	}

	return (
		<div class="gui_best_score" style={styles}>
			<svg xmlns="http://www.w3.org/2000/svg" width="145" height="123" viewBox="0 0 145 123">
				<g class="circle">
					<circle
						class="bg"
						cx="72.3"
						cy="61.5"
						r="48.5"
					/>

					<circle
						class="stroke"
						cx="72.3"
						cy="61.5"
						r="48.5"
					/>

					<path
						class="shadow"
						d="M94.49,103.92c-7.05-1.1-14.5-1.66-22.15-1.66c-7.65,0-15.1,0.56-22.15,1.66l-0.27,0.04l-0.14-0.08c-6.6-3.51-12.38-8.61-16.71-14.75l-0.56-0.79h79.61l-0.56,0.79c-4.33,6.14-10.1,11.24-16.68,14.75l-0.15,0.08L94.49,103.92z"
					/>
				</g>

				<g class="like">
					<path
						class="hand"
						d="M92.25,42.9c-0.09-0.31-0.02-0.64,0.18-0.89c1.38-1.74,1.37-4.08,0.79-5.52c-0.1-0.24-0.1-0.51,0-0.75c0.73-1.81,1.03-4.31,0.17-5.58c-0.21-0.31-0.23-0.71-0.05-1.04c1.2-2.25,1.31-4.32,0.31-6c-1.01-1.69-2.76-2.44-3.68-2.44c-0.06,0-0.11,0-0.17,0.01l-9.4,1.16c-0.04,0.01-0.08,0.01-0.12,0.01c-0.36,0-0.69-0.19-0.87-0.51c-0.2-0.35-0.16-0.79,0.09-1.11c0.66-0.84,2.21-6.74,0.91-10.43c-0.49-1.39-1.3-2.19-2.47-2.45C76.92,7.11,76.06,7,75.36,7c-1.87,0-2.07,0.71-2.41,1.88c-0.06,0.22-0.13,0.44-0.2,0.65c-0.2,0.56-0.27,1.59-0.34,2.58c-0.11,1.61-0.23,3.28-0.89,4.37c-0.4,0.65-1.2,1.89-2.12,3.34c-1.24,1.93-2.64,4.12-3.29,5.21c-1.22,2.04-2.74,2.75-5.14,3.14l2.59,21.09c0.53-0.04,1.08-0.06,1.64-0.06c2.46,0,4.83,0.37,7.34,0.76c2.66,0.42,5.41,0.85,8.44,0.85c1.26,0,2.47-0.07,3.7-0.22c3.61-0.44,6.01-1.52,7.13-3.21C92.79,45.87,92.6,44.11,92.25,42.9z"
					/>

					<path
						class="main_color"
						d="M94.21,29.59c3.34-6.23-1.69-9.92-4.26-9.92c-0.1,0-0.2,0.01-0.29,0.02c-2.45,0.3-4.38,0.54-9.4,1.16C81.59,19.19,84,7.68,78.15,6.36C77.01,6.11,76.1,6,75.36,6c-3.06,0-3.09,1.89-3.55,3.19c-0.57,1.61-0.2,5.23-1.14,6.76c-0.93,1.53-4.28,6.66-5.42,8.56c-1,1.67-2.17,2.29-4.41,2.66c-0.07-0.54-0.57-0.92-1.11-0.86L46.2,27.97c-0.26,0.03-0.5,0.17-0.67,0.38c-0.16,0.21-0.24,0.47-0.2,0.74l2.83,23.04c0.06,0.51,0.49,0.88,0.99,0.88c0.04,0,0.08,0,0.12-0.01l13.53-1.66c0.26-0.03,0.5-0.17,0.67-0.38c0.16-0.2,0.22-0.45,0.2-0.7c0.51-0.04,1.02-0.06,1.52-0.06c4.99,0,9.83,1.61,15.78,1.61c1.22,0,2.49-0.07,3.82-0.23c8.88-1.09,9.3-5.79,8.42-8.93c1.58-1.99,1.67-4.69,0.93-6.52C94.97,34.09,95.32,31.23,94.21,29.59z M53.53,48.53c-1.12,0.14-2.14-0.66-2.28-1.78c-0.14-1.12,0.66-2.14,1.78-2.28c1.12-0.14,2.14,0.66,2.28,1.78C55.45,47.37,54.65,48.39,53.53,48.53z M92.45,28.64c-0.35,0.66-0.31,1.45,0.11,2.07c0.56,0.82,0.44,2.91-0.26,4.64c-0.19,0.48-0.19,1.02,0,1.5c0.48,1.18,0.48,3.1-0.65,4.52c-0.4,0.5-0.53,1.17-0.36,1.78c0.41,1.47,0.31,2.7-0.32,3.64c-0.94,1.41-3.16,2.37-6.42,2.77c-1.18,0.15-2.35,0.22-3.58,0.22c-2.95,0-5.67-0.42-8.29-0.83c-2.55-0.4-4.96-0.78-7.5-0.78c-0.26,0-0.51,0-0.76,0.01l-2.36-19.23c2.14-0.48,3.66-1.37,4.89-3.43c0.64-1.08,2.04-3.26,3.28-5.19c0.93-1.45,1.73-2.7,2.13-3.35c0.79-1.29,0.92-3.09,1.04-4.82c0.06-0.84,0.13-1.88,0.28-2.31c0.08-0.22,0.15-0.46,0.22-0.71C74.21,8.11,74.25,8,75.36,8c0.62,0,1.41,0.11,2.35,0.32c0.52,0.12,1.19,0.41,1.67,1.61c1.24,3.1-0.03,8.69-0.68,9.67c-0.5,0.64-0.57,1.51-0.18,2.22c0.36,0.64,1.03,1.02,1.74,1.02c0.08,0,0.16,0,0.24-0.01l9.45-1.16c0.56,0,2.01,0.59,2.83,1.96C93.61,25.01,93.5,26.7,92.45,28.64z"
					/>
				</g>

				<g class="laurel">
					<path
						class="main_color"
						d="M52.18,67.04c-3.89,2.18-5.74,5.28-7.56,6.83c7.83,0.42,12.33,0.25,16.2-6.47C60.82,67.4,56.07,64.86,52.18,67.04z"
					/>

					<path
						class="main_color"
						d="M52.3,66.31c0,0,1.99-4.94-0.68-8.47c-2.67-3.53-6.03-4.96-7.82-6.55C44.33,58.98,45.03,63.34,52.3,66.31z"
					/>

					<path
						class="main_color"
						d="M41.16,63.95c0,0,3.08-4.38,1.3-8.4c-1.78-4.01-4.75-6.19-6.1-8.11C35.1,55.04,34.78,59.44,41.16,63.95z"
					/>

					<path
						class="main_color"
						d="M31.93,56.29c0,0,3.49-4.06,2.1-8.24c-1.39-4.19-4.12-6.58-5.29-8.64C26.75,46.85,26,51.21,31.93,56.29z"
					/>

					<path
						class="main_color"
						d="M27.26,39.26c-0.46-4.37-2.61-7.29-3.32-9.54c-3.54,6.87-5.21,10.97-0.51,17.16C23.43,46.88,27.7,43.64,27.26,39.26z"
					/>

					<path
						class="main_color"
						d="M18.83,42.35c0,0,1.1-5.17-2.16-8.22c-3.26-3.05-6.84-3.85-8.85-5.12C9.68,36.49,11.14,40.66,18.83,42.35z"
					/>

					<path
						class="main_color"
						d="M25.56,51.5c-3.22-7.05-7.67-7.65-15.51-7.93c1.66,1.71,3.21,4.97,6.87,7.49C20.59,53.59,25.56,51.5,25.56,51.5z"
					/>

					<path
						class="main_color"
						d="M32.08,57.32c-5.97-5.02-10.26-3.67-17.48-0.68c2.25,0.85,5.06,3.15,9.48,3.9C28.5,61.28,32.08,57.32,32.08,57.32z"
					/>

					<path
						class="main_color"
						d="M39.34,63.6c-6.25-4.69-10.45-3.09-17.49,0.29c2.28,0.7,5.24,2.86,9.69,3.37C35.99,67.77,39.34,63.6,39.34,63.6z"
					/>

					<path
						class="main_color"
						d="M49.42,66.22c-7.08-3.37-10.88-0.99-17.07,3.74c2.39,0.26,5.72,1.78,10.17,1.4C46.99,70.99,49.42,66.22,49.42,66.22z"
					/>

					<path
						class="main_color"
						d="M88.47,67.04c-3.89-2.18-8.64,0.36-8.64,0.36c3.88,6.72,8.37,6.89,16.2,6.47C94.21,72.32,92.36,69.21,88.47,67.04z"
					/>

					<path
						class="main_color"
						d="M96.85,51.3c-1.79,1.59-5.15,3.01-7.82,6.55c-2.67,3.53-0.68,8.47-0.68,8.47C95.62,63.34,96.31,58.98,96.85,51.3z"
					/>

					<path
						class="main_color"
						d="M104.29,47.44c-1.35,1.93-4.32,4.1-6.1,8.11s1.3,8.4,1.3,8.4C105.87,59.44,105.55,55.04,104.29,47.44z"
					/>

					<path
						class="main_color"
						d="M111.92,39.4c-1.18,2.06-3.9,4.45-5.29,8.64c-1.39,4.19,2.1,8.24,2.1,8.24C114.65,51.21,113.9,46.85,111.92,39.4z"
					/>

					<path
						class="main_color"
						d="M117.21,46.88c4.7-6.19,3.04-10.29-0.51-17.16c-0.71,2.26-2.86,5.17-3.32,9.54C112.95,43.64,117.21,46.88,117.21,46.88z"
					/>

					<path
						class="main_color"
						d="M132.82,29c-2.01,1.27-5.59,2.07-8.85,5.12c-3.26,3.05-2.16,8.22-2.16,8.22C129.51,40.66,130.97,36.49,132.82,29z"
					/>

					<path
						class="main_color"
						d="M115.08,51.5c0,0,4.98,2.09,8.64-0.44c3.66-2.53,5.21-5.78,6.87-7.49C122.75,43.85,118.3,44.45,115.08,51.5z"
					/>

					<path
						class="main_color"
						d="M108.56,57.32c0,0,3.59,3.96,8,3.22c4.41-0.74,7.23-3.05,9.48-3.9C118.82,53.64,114.53,52.29,108.56,57.32z"
					/>

					<path
						class="main_color"
						d="M101.31,63.6c0,0,3.35,4.17,7.8,3.66c4.45-0.51,7.4-2.67,9.69-3.37C111.76,60.51,107.56,58.91,101.31,63.6z"
					/>

					<path
						class="main_color"
						d="M91.22,66.22c0,0,2.44,4.77,6.89,5.14c4.46,0.38,7.78-1.15,10.17-1.4C102.11,65.23,98.3,62.85,91.22,66.22z"
					/>
				</g>
			</svg>

			<div
				class="textual_part original_color_item"
			>{i18n("Your best score")}</div>
		</div>
	)
}

export default injectIntl(BestScore);